var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,on:{"click":function($event){return _vm.clicked()}}},[_c('svg',{attrs:{"width":"6","height":"5","viewBox":"0 0 6 5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"3","cy":"2.5","r":"2.5","fill":"white"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }